import { Box, Skeleton } from '@mui/material';
import { useL10n, useViewMoreList } from '@uplift/hooks';
import { EmptyActionItem } from '@uplift/pages';
import { Button, ExpandableDashboardActionItemProps, StackableCardDeck } from '@uplift/ui-v2';

export type ToDoListItemExpandableType = {
  id: string;
} & Omit<ExpandableDashboardActionItemProps, 'isExpanded' | 'onExpandedChange'>;

export type ToDosListProps = {
  toDos: JSX.Element[];
  loading?: boolean;
};

export const ToDosList: React.FC<ToDosListProps> = ({ toDos, loading = false }) => {
  const l10n = useL10n();
  const { viewableList, onViewMore, viewMoreDisabled } = useViewMoreList({
    list: toDos,
    initialViewAmount: 10,
    viewMoreAmount: 10
  });

  if (loading) {
    return <Skeleton width="100%" height="200px" variant="rectangular" />;
  }

  return (
    <Box>
      <StackableCardDeck>
        {toDos.length === 0 && <EmptyActionItem title={l10n.dashboard.toDo.nothingToDo} />}
        {viewableList}
      </StackableCardDeck>
      {!viewMoreDisabled && (
        <Box textAlign="center" mt={3}>
          <Button onClick={onViewMore}>{l10n.general.viewMore}</Button>
        </Box>
      )}
    </Box>
  );
};
